import {
	UserProfileDeleteRequestParams,
	UserProfileLogoutSuccessResponseData,
	UserProfileFormValues,
	UserProfileData,
} from './types';
import { USER_DELETE_PROFILE_URL, USER_LOGOUT_URL, USER_PROFILE_URL } from './const';
import { GET, POST } from '@packages/dataFetch';

export const getUserProfile = async () => {
	const response = await GET<UserProfileData>(USER_PROFILE_URL);

	return response.data;
};

export const updateUserProfile = async (data: UserProfileFormValues) => {
	const response = await POST<unknown>(USER_PROFILE_URL, { data });

	return response.data;
};

export const deleteUserProfile = async (data: UserProfileDeleteRequestParams) => {
	const response = await POST<unknown>(USER_DELETE_PROFILE_URL, { data });

	return response.data;
};

export const userLogout = async () => {
	const response = await POST<UserProfileLogoutSuccessResponseData>(USER_LOGOUT_URL);

	return response.data;
};
